import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
import { chevron_right } from "../../Images/Icons";

const CoachMarkStep10 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop_with_img}>
                <div className={css.higlight10}>
                    
                    <div className={css.content}>
                        
                        <div className={css.point}>
                            <img src={coachmark_pin}/>
                        </div>
                        <i class="fi fi-rr-cross-small"></i>
                        <div className={css.title}>🛠️ Choose Plant Management!</div>
                        <div className={css.desc}>
                            Click here to choose one of your plant's performance. <br/><br/>
                            'Choose Plant Management' allows you to select the specific plant or energy system you want to focus on. 
                        </div>
                        <div className={css.step}>10/10</div>
                        <NavLink to="/home" onClick={props.prev}>
                            <button className={css.prev}>Previous</button>
                        </NavLink>
                        <NavLink to="/home">
                            <button className={css.next} onClick={props.next}>Finish</button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep10;
